import { Card, CardActionArea, Typography } from '@mui/material'
import { Stack } from '@mui/system'
import VerifiedIcon from '@mui/icons-material/Verified'

export const PlanPurchaseCard: React.FC<{
  title: string
  mainPriceSection?: React.ReactNode
  secondaryPriceSection?: React.ReactNode
  onClick(): void
  isSelected: boolean
  isFeatured?: boolean
}> = ({ title, mainPriceSection, secondaryPriceSection, onClick, isSelected, isFeatured }) => {
  return (
    <Card
      variant="outlined"
      sx={{
        width: '100%',
        borderColor: isSelected ? 'black' : 'auto',
        backgroundColor: isSelected ? 'surface.2' : 'unset'
      }}
      onClick={onClick}
    >
      <CardActionArea>
        <Stack sx={{ p: 5 }}>
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Typography variant="subtitleSmall">{title}</Typography>
            {isFeatured && <VerifiedIcon color="success" fontSize="small" />}
          </Stack>
          <Stack direction="row" gap={2} alignItems="center">
            {mainPriceSection}
          </Stack>
          {secondaryPriceSection}
        </Stack>
      </CardActionArea>
    </Card>
  )
}
